import { Component, inject, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-docusign-callback',
  template: ``,
  styles: []
})
export class DocusignCallbackComponent implements OnInit {
  private route: ActivatedRoute = inject(ActivatedRoute);

  ngOnInit(): void {
    this.route.queryParams.subscribe(params => {
      const event = params['event'];

      if (event) {
        window.parent.postMessage(
          {
            type: 'DOCUSIGN_EVENT',
            event: event
          },
          window.location.origin
        );
      }
    });
  }
}
